import { Body } from '@panwds/react-ui'
import { HUMAN_READABLE_DEVICE_LICENSE_TYPE } from '../../../../constants/LabelConstants'

const LicenseActivatedRenderer = ({ row, selectedApp }) => {
  const app = row?.original?.associations?.find(({ app_id }) => selectedApp?.app_id === app_id)
  const { extra } = app || {}
  return <Body size="lg" addClassName='tw-truncate'>{HUMAN_READABLE_DEVICE_LICENSE_TYPE[extra?.license_type?.toLowerCase()]}</Body>
}

LicenseActivatedRenderer.propTypes = {}
export default LicenseActivatedRenderer
